import {
  FETCH_BALANCES_SUCCESS,
  FETCH_BALANCES_FAIL,
  FETCH_DAILY_PRICES_SUCCESS,
  FETCH_DAILY_PRICES_FAIL,
  FETCH_LAST_LOGIN_VALUE_SUCCESS,
  FETCH_LAST_LOGIN_VALUE_FAIL,
  FETCH_FX_SNAPSHOT_DAY_SUCCESS,
  FETCH_FX_SNAPSHOT_DAY_FAIL,
  FETCH_FX_SNAPSHOT_WEEK_SUCCESS,
  FETCH_FX_SNAPSHOT_WEEK_FAIL,
} from '../actions/types';

const initialState = {
  balance: {},
  daily: [],
  lastFx: {},
  fxSnapDay: {},
  fxSnapWeek: {},
  errors: [],
};

const balance = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_BALANCES_SUCCESS:
      return {
        ...state,
        balance: action.payload,
        loading: false,
      };
    case FETCH_BALANCES_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.payload,
      };
    case FETCH_DAILY_PRICES_SUCCESS:
      return {
        ...state,
        daily: action.payload,
        loading: false,
      };
    case FETCH_DAILY_PRICES_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.payload,
      };
    case FETCH_LAST_LOGIN_VALUE_SUCCESS:
      return {
        ...state,
        lastFx: action.payload,
        loading: false,
      };
    case FETCH_LAST_LOGIN_VALUE_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.payload,
      };
    case FETCH_FX_SNAPSHOT_DAY_SUCCESS:
      return {
        ...state,
        fxSnapDay: action.payload,
        loading: false,
      };
    case FETCH_FX_SNAPSHOT_DAY_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.payload,
      };
    case FETCH_FX_SNAPSHOT_WEEK_SUCCESS:
      return {
        ...state,
        fxSnapWeek: action.payload,
        loading: false,
      };
    case FETCH_FX_SNAPSHOT_WEEK_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.payload,
      };
    default:
      return state;
  }
};

export default balance;
